/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Type_EnterpriseInputs */

const en_customer_type_enterprise = /** @type {(inputs: Customer_Type_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const es_customer_type_enterprise = /** @type {(inputs: Customer_Type_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresarial`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {Customer_Type_EnterpriseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const customer_type_enterprise = /** @type {((inputs?: Customer_Type_EnterpriseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Type_EnterpriseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_customer_type_enterprise(inputs)
	return es_customer_type_enterprise(inputs)
});